/* eslint-disable class-methods-use-this */

import { Mark } from 'tiptap'
import { updateMark, markInputRule } from 'tiptap-commands'


export class Color extends Mark {
  get name() {
    return 'color'
  }

  get schema() {
    return {
      attrs: {
        color: {
        },
      },
      parseDOM: [{
        style: 'color',
        getAttrs: (value) => ({
          color: value,
        }),
      }],
      toDOM: (mark) => ['span', {
        style: `color: ${mark.attrs.color}`,
      }, 0],
    }
  }

  commands({ type }) {
    return (attrs) => updateMark(type, attrs)
  }

  inputRules({ type }) {
    return [
      markInputRule(/(?:\*\*|__)([^*_]+)(?:\*\*|__)$/, type),
    ]
  }
}
